import * as endpoints from './endpoints';

const ContentService = { ...endpoints };

export default ContentService;
export type { ContentCatalogItem, CustomContent } from './endpoints';
